/** Built-in value references. */
var Reflect = global.Reflect;

module.exports = Reflect;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Reflect.js
 ** module id = 334
 ** module chunks = 0
 **/